"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties");

require("core-js/modules/es7.promise.finally");

require("core-js/modules/es6.array.sort");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.seal");

require("core-js/modules/es6.object.is-frozen");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.keys");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.from");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.freeze");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

require("core-js/modules/es6.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.set");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _interopDefault(ex) {
  return ex && "object" == typeof ex && "default" in ex ? ex["default"] : ex;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var react = _interopDefault(require("react")),
    reactDom = _interopDefault(require("react-dom"));

var Recoil_CopyOnWrite = {
  setByAddingToSet: function setByAddingToSet(set, v) {
    var next = new Set(set);
    return next.add(v), next;
  },
  setByDeletingFromSet: function setByDeletingFromSet(set, v) {
    var next = new Set(set);
    return next["delete"](v), next;
  },
  mapBySettingInMap: function mapBySettingInMap(map, k, v) {
    var next = new Map(map);
    return next.set(k, v), next;
  },
  mapByUpdatingInMap: function mapByUpdatingInMap(map, k, updater) {
    var next = new Map(map);
    return next.set(k, updater(next.get(k))), next;
  },
  mapByDeletingFromMap: function mapByDeletingFromMap(map, k) {
    var next = new Map(map);
    return next["delete"](k), next;
  }
};

var AbstractRecoilValue = function AbstractRecoilValue(newKey) {
  _classCallCheck(this, AbstractRecoilValue);

  this.key = newKey;
};

var Recoil_RecoilValueClasses = {
  AbstractRecoilValue: AbstractRecoilValue,
  RecoilState: /*#__PURE__*/function (_AbstractRecoilValue) {
    _inherits(RecoilState, _AbstractRecoilValue);

    var _super = _createSuper(RecoilState);

    function RecoilState() {
      _classCallCheck(this, RecoilState);

      return _super.apply(this, arguments);
    }

    return RecoilState;
  }(AbstractRecoilValue),
  RecoilValueReadOnly: /*#__PURE__*/function (_AbstractRecoilValue2) {
    _inherits(RecoilValueReadOnly, _AbstractRecoilValue2);

    var _super2 = _createSuper(RecoilValueReadOnly);

    function RecoilValueReadOnly() {
      _classCallCheck(this, RecoilValueReadOnly);

      return _super2.apply(this, arguments);
    }

    return RecoilValueReadOnly;
  }(AbstractRecoilValue)
};

var DefaultValue = function DefaultValue() {
  _classCallCheck(this, DefaultValue);
};

var DEFAULT_VALUE = new DefaultValue();

var RecoilValueNotReady = /*#__PURE__*/function (_Error) {
  _inherits(RecoilValueNotReady, _Error);

  var _super3 = _createSuper(RecoilValueNotReady);

  function RecoilValueNotReady(key) {
    _classCallCheck(this, RecoilValueNotReady);

    return _super3.call(this, "Tried to set the value of Recoil selector ".concat(key, " using an updater function, but it is an async selector in a pending or error state; this is not supported."));
  }

  return RecoilValueNotReady;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var nodes = new Map();

var NodeMissingError = /*#__PURE__*/function (_Error2) {
  _inherits(NodeMissingError, _Error2);

  var _super4 = _createSuper(NodeMissingError);

  function NodeMissingError() {
    _classCallCheck(this, NodeMissingError);

    return _super4.apply(this, arguments);
  }

  return NodeMissingError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Recoil_Node = {
  nodes: nodes,
  registerNode: function registerNode(node) {
    if (nodes.has(node.key)) {
      node.key;
    }

    return nodes.set(node.key, node), null == node.set ? new Recoil_RecoilValueClasses.RecoilValueReadOnly(node.key) : new Recoil_RecoilValueClasses.RecoilState(node.key);
  },
  getNode: function getNode(key) {
    var node = nodes.get(key);
    if (null == node) throw new NodeMissingError("Missing definition for RecoilValue: \"".concat(key, "\"\""));
    return node;
  },
  NodeMissingError: NodeMissingError,
  DefaultValue: DefaultValue,
  DEFAULT_VALUE: DEFAULT_VALUE,
  RecoilValueNotReady: RecoilValueNotReady
};
var Recoil_Tracing = {
  trace: function trace(message, node, fn) {
    return fn();
  },
  wrap: function wrap(fn) {
    return fn;
  }
};
var mapByDeletingFromMap$1 = Recoil_CopyOnWrite.mapByDeletingFromMap,
    mapBySettingInMap$1 = Recoil_CopyOnWrite.mapBySettingInMap,
    mapByUpdatingInMap$1 = Recoil_CopyOnWrite.mapByUpdatingInMap,
    setByAddingToSet$1 = Recoil_CopyOnWrite.setByAddingToSet,
    getNode$1 = Recoil_Node.getNode,
    emptyMap = Object.freeze(new Map()),
    emptySet = Object.freeze(new Set());

var ReadOnlyRecoilValueError = /*#__PURE__*/function (_Error3) {
  _inherits(ReadOnlyRecoilValueError, _Error3);

  var _super5 = _createSuper(ReadOnlyRecoilValueError);

  function ReadOnlyRecoilValueError() {
    _classCallCheck(this, ReadOnlyRecoilValueError);

    return _super5.apply(this, arguments);
  }

  return ReadOnlyRecoilValueError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function getNodeLoadable(store, state, key) {
  return getNode$1(key).get(store, state);
}

var subscriptionID = 0;
var Recoil_FunctionalCore = {
  getNodeLoadable: getNodeLoadable,
  peekNodeLoadable: function peekNodeLoadable(store, state, key) {
    return getNodeLoadable(store, state, key)[1];
  },
  setNodeValue: function setNodeValue(store, state, key, newValue) {
    var node = getNode$1(key);
    if (null == node.set) throw new ReadOnlyRecoilValueError("Attempt to set read-only RecoilValue: " + key);

    var _node$set = node.set(store, state, newValue),
        _node$set2 = _slicedToArray(_node$set, 2),
        newState = _node$set2[0],
        writtenNodes = _node$set2[1];

    return [newState, writtenNodes];
  },
  setUnvalidatedAtomValue: function setUnvalidatedAtomValue(state, key, newValue) {
    return _objectSpread(_objectSpread({}, state), {}, {
      atomValues: mapByDeletingFromMap$1(state.atomValues, key),
      nonvalidatedAtoms: mapBySettingInMap$1(state.nonvalidatedAtoms, key, newValue),
      dirtyAtoms: setByAddingToSet$1(state.dirtyAtoms, key)
    });
  },
  subscribeComponentToNode: function subscribeComponentToNode(state, key, callback) {
    var subID = subscriptionID++;
    return [_objectSpread(_objectSpread({}, state), {}, {
      nodeToComponentSubscriptions: mapByUpdatingInMap$1(state.nodeToComponentSubscriptions, key, function (subsForAtom) {
        return mapBySettingInMap$1(null != subsForAtom ? subsForAtom : emptyMap, subID, ["TODO debug name", callback]);
      })
    }), function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        nodeToComponentSubscriptions: mapByUpdatingInMap$1(state.nodeToComponentSubscriptions, key, function (subsForAtom) {
          return mapByDeletingFromMap$1(null != subsForAtom ? subsForAtom : emptyMap, subID);
        })
      });
    }];
  },
  fireNodeSubscriptions: function fireNodeSubscriptions(store, updatedNodes, when) {
    var _store$getState$nextT;

    var state = "enqueue" === when && null !== (_store$getState$nextT = store.getState().nextTree) && void 0 !== _store$getState$nextT ? _store$getState$nextT : store.getState().currentTree,
        dependentNodes = function (state, keys) {
      var dependentNodes = new Set(),
          visitedNodes = new Set(),
          visitingNodes = Array.from(keys);

      for (var key = visitingNodes.pop(); key; key = visitingNodes.pop()) {
        var _state$nodeToNodeSubs;

        dependentNodes.add(key), visitedNodes.add(key);
        var subscribedNodes = null !== (_state$nodeToNodeSubs = state.nodeToNodeSubscriptions.get(key)) && void 0 !== _state$nodeToNodeSubs ? _state$nodeToNodeSubs : emptySet;

        var _iterator = _createForOfIteratorHelper(subscribedNodes),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var downstreamNode = _step.value;
            visitedNodes.has(downstreamNode) || visitingNodes.push(downstreamNode);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return dependentNodes;
    }(state, updatedNodes);

    var _iterator2 = _createForOfIteratorHelper(dependentNodes),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;

        var _state$nodeToComponen;

        (null !== (_state$nodeToComponen = state.nodeToComponentSubscriptions.get(key)) && void 0 !== _state$nodeToComponen ? _state$nodeToComponen : []).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              debugName = _ref2[0],
              cb = _ref2[1];

          "enqueue" === when ? store.getState().queuedComponentCallbacks.push(cb) : cb(state);
        });
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    Recoil_Tracing.trace("value became available, waking components", Array.from(updatedNodes).join(", "), function () {
      var resolvers = store.getState().suspendedComponentResolvers;
      resolvers.forEach(function (r) {
        return r();
      }), resolvers.clear();
    });
  },
  detectCircularDependencies: function detectCircularDependencies(state, stack) {
    if (!stack.length) return;
    var leaf = stack[stack.length - 1],
        downstream = state.nodeToNodeSubscriptions.get(leaf);
    if (!(null == downstream ? void 0 : downstream.size)) return;
    var root = stack[0];
    if (downstream.has(root)) throw new Error("Recoil selector has circular dependencies: " + [].concat(_toConsumableArray(stack), [root]).reverse().join(" → "));

    var _iterator3 = _createForOfIteratorHelper(downstream),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var next = _step3.value;
        detectCircularDependencies(state, [].concat(_toConsumableArray(stack), [next]));
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
};

var Recoil_nullthrows = function Recoil_nullthrows(x, message) {
  if (null != x) return x;
  throw new Error(null != message ? message : "Got unexpected null or undefined");
};

var Recoil_Queue = {
  enqueueExecution: function enqueueExecution(s, f) {
    f();
  }
};
var useContext = react.useContext,
    useEffect = react.useEffect,
    useRef = react.useRef,
    useState = react.useState,
    fireNodeSubscriptions$1 = Recoil_FunctionalCore.fireNodeSubscriptions,
    setNodeValue$1 = Recoil_FunctionalCore.setNodeValue,
    setUnvalidatedAtomValue$1 = Recoil_FunctionalCore.setUnvalidatedAtomValue;

function notInAContext() {
  throw new Error("This component must be used inside a <RecoilRoot> component.");
}

var defaultStore = Object.freeze({
  getState: notInAContext,
  replaceState: notInAContext,
  subscribeToTransactions: notInAContext,
  addTransactionMetadata: notInAContext,
  fireNodeSubscriptions: notInAContext
});

function startNextTreeIfNeeded(storeState) {
  null === storeState.nextTree && (storeState.nextTree = _objectSpread(_objectSpread({}, storeState.currentTree), {}, {
    dirtyAtoms: new Set(),
    transactionMetadata: {}
  }));
}

var AppContext = react.createContext({
  current: defaultStore
}),
    useStoreRef = function useStoreRef() {
  return useContext(AppContext);
};

function Batcher(props) {
  var storeRef = useStoreRef(),
      _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      _ = _useState2[0],
      setState = _useState2[1];

  return props.setNotifyBatcherOfChange(function () {
    return setState({});
  }), useEffect(function () {
    Recoil_Queue.enqueueExecution("Batcher", function () {
      var storeState = storeRef.current.getState(),
          currentTree = storeState.currentTree,
          nextTree = storeState.nextTree;
      null !== nextTree && (nextTree.dirtyAtoms.size && storeState.transactionSubscriptions.forEach(function (sub) {
        return sub(storeRef.current, currentTree);
      }), storeState.queuedComponentCallbacks.forEach(function (cb) {
        return cb(nextTree);
      }), storeState.queuedComponentCallbacks.splice(0, storeState.queuedComponentCallbacks.length), storeState.currentTree = nextTree, storeState.nextTree = null);
    });
  }), null;
}

function initialStoreState(store, initializeState) {
  var initial = {
    currentTree: {
      isSnapshot: !1,
      transactionMetadata: {},
      atomValues: new Map(),
      nonvalidatedAtoms: new Map(),
      dirtyAtoms: new Set(),
      nodeDeps: new Map(),
      nodeToNodeSubscriptions: new Map(),
      nodeToComponentSubscriptions: new Map()
    },
    nextTree: null,
    transactionSubscriptions: new Map(),
    queuedComponentCallbacks: [],
    suspendedComponentResolvers: new Set()
  };
  return initializeState && initializeState({
    set: function set(atom, value) {
      initial.currentTree = setNodeValue$1(store, initial.currentTree, atom.key, value)[0];
    },
    setUnvalidatedAtomValues: function setUnvalidatedAtomValues(atomValues) {
      atomValues.forEach(function (v, k) {
        initial.currentTree = setUnvalidatedAtomValue$1(initial.currentTree, k, v);
      });
    }
  }), initial;
}

var nextID = 0;
var Recoil_RecoilRoot_react = {
  useStoreRef: useStoreRef,
  RecoilRoot: function RecoilRoot(_ref3) {
    var initializeState = _ref3.initializeState,
        children = _ref3.children;
    var storeState;
    var notifyBatcherOfChange = useRef(null),
        store = {
      getState: function getState() {
        return storeState.current;
      },
      replaceState: function replaceState(replacer) {
        var storeState = storeRef.current.getState();
        startNextTreeIfNeeded(storeState);
        var nextTree = Recoil_nullthrows(storeState.nextTree),
            replaced = replacer(nextTree);
        replaced !== nextTree && (storeState.nextTree = replaced, Recoil_nullthrows(notifyBatcherOfChange.current)());
      },
      subscribeToTransactions: function subscribeToTransactions(callback) {
        var id = nextID++;
        return storeRef.current.getState().transactionSubscriptions.set(id, callback), {
          release: function release() {
            storeRef.current.getState().transactionSubscriptions["delete"](id);
          }
        };
      },
      addTransactionMetadata: function addTransactionMetadata(metadata) {
        startNextTreeIfNeeded(storeRef.current.getState());

        for (var _i = 0, _Object$keys = Object.keys(metadata); _i < _Object$keys.length; _i++) {
          var k = _Object$keys[_i];
          Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
        }
      },
      fireNodeSubscriptions: function fireNodeSubscriptions(updatedNodes, when) {
        fireNodeSubscriptions$1(storeRef.current, updatedNodes, when);
      }
    },
        storeRef = useRef(store);
    return storeState = useRef(initialStoreState(store, initializeState)), react.createElement(AppContext.Provider, {
      value: storeRef
    }, react.createElement(Batcher, {
      setNotifyBatcherOfChange: function setNotifyBatcherOfChange(x) {
        notifyBatcherOfChange.current = x;
      }
    }), children);
  }
};
var getNodeLoadable$1 = Recoil_FunctionalCore.getNodeLoadable,
    peekNodeLoadable$1 = Recoil_FunctionalCore.peekNodeLoadable,
    setNodeValue$2 = Recoil_FunctionalCore.setNodeValue,
    setUnvalidatedAtomValue$2 = Recoil_FunctionalCore.setUnvalidatedAtomValue,
    subscribeComponentToNode$1 = Recoil_FunctionalCore.subscribeComponentToNode,
    AbstractRecoilValue$1 = Recoil_RecoilValueClasses.AbstractRecoilValue,
    RecoilState$1 = Recoil_RecoilValueClasses.RecoilState,
    RecoilValueReadOnly$1 = Recoil_RecoilValueClasses.RecoilValueReadOnly;
var Recoil_RecoilValue = {
  RecoilValueReadOnly: RecoilValueReadOnly$1,
  AbstractRecoilValue: AbstractRecoilValue$1,
  RecoilState: RecoilState$1,
  peekRecoilValueAsLoadable: function peekRecoilValueAsLoadable(store, _ref4) {
    var key = _ref4.key;
    var state = store.getState().currentTree;
    return peekNodeLoadable$1(store, state, key);
  },
  getRecoilValueAsLoadable: function getRecoilValueAsLoadable(store, _ref5) {
    var key = _ref5.key;
    var result;
    return Recoil_Tracing.trace("get RecoilValue", key, function () {
      return store.replaceState(Recoil_Tracing.wrap(function (state) {
        var _getNodeLoadable$ = getNodeLoadable$1(store, state, key),
            _getNodeLoadable$2 = _slicedToArray(_getNodeLoadable$, 2),
            newState = _getNodeLoadable$2[0],
            loadable = _getNodeLoadable$2[1];

        return result = loadable, newState;
      }));
    }), result;
  },
  setRecoilValue: function setRecoilValue(store, _ref6, newValue) {
    var key = _ref6.key;
    Recoil_Tracing.trace("set RecoilValue", key, function () {
      return store.replaceState(Recoil_Tracing.wrap(function (state) {
        var _setNodeValue$ = setNodeValue$2(store, state, key, newValue),
            _setNodeValue$2 = _slicedToArray(_setNodeValue$, 2),
            newState = _setNodeValue$2[0],
            writtenNodes = _setNodeValue$2[1];

        return store.fireNodeSubscriptions(writtenNodes, "enqueue"), newState;
      }));
    });
  },
  setUnvalidatedRecoilValue: function setUnvalidatedRecoilValue(store, _ref7, newValue) {
    var key = _ref7.key;
    Recoil_Tracing.trace("set unvalidated persisted atom", key, function () {
      return store.replaceState(Recoil_Tracing.wrap(function (state) {
        var newState = setUnvalidatedAtomValue$2(state, key, newValue);
        return store.fireNodeSubscriptions(new Set([key]), "enqueue"), newState;
      }));
    });
  },
  subscribeToRecoilValue: function subscribeToRecoilValue(store, _ref8, callback) {
    var key = _ref8.key;
    var newState, releaseFn;
    return Recoil_Tracing.trace("subscribe component to RecoilValue", key, function () {
      return store.replaceState(Recoil_Tracing.wrap(function (state) {
        var _subscribeComponentTo, _subscribeComponentTo2;

        return (_subscribeComponentTo = subscribeComponentToNode$1(state, key, callback), _subscribeComponentTo2 = _slicedToArray(_subscribeComponentTo, 2), newState = _subscribeComponentTo2[0], releaseFn = _subscribeComponentTo2[1], _subscribeComponentTo), newState;
      }));
    }), {
      release: function release(store) {
        return store.replaceState(releaseFn);
      }
    };
  },
  isRecoilValue: function isRecoilValue(x) {
    return x instanceof RecoilState$1 || x instanceof RecoilValueReadOnly$1;
  }
};

var Recoil_differenceSets = function Recoil_differenceSets(set) {
  var ret = new Set();

  for (var _len = arguments.length, setsWithValuesToRemove = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    setsWithValuesToRemove[_key - 1] = arguments[_key];
  }

  var _iterator4 = _createForOfIteratorHelper(set),
      _step4;

  try {
    FIRST: for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var value = _step4.value;

      var _iterator5 = _createForOfIteratorHelper(setsWithValuesToRemove),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var otherSet = _step5.value;
          if (otherSet.has(value)) continue FIRST;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      ret.add(value);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return ret;
};

var Recoil_filterMap = function Recoil_filterMap(map, callback) {
  var result = new Map();

  var _iterator6 = _createForOfIteratorHelper(map),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var _step6$value = _slicedToArray(_step6.value, 2),
          key = _step6$value[0],
          value = _step6$value[1];

      callback(value, key) && result.set(key, value);
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return result;
};

var Recoil_intersectSets = function Recoil_intersectSets(first) {
  var ret = new Set();

  for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    rest[_key2 - 1] = arguments[_key2];
  }

  var _iterator7 = _createForOfIteratorHelper(first),
      _step7;

  try {
    FIRST: for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var value = _step7.value;

      var _iterator8 = _createForOfIteratorHelper(rest),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var otherSet = _step8.value;
          if (!otherSet.has(value)) continue FIRST;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      ret.add(value);
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  return ret;
};

var Recoil_invariant = function Recoil_invariant(condition, message) {
  if (!condition) throw new Error(message);
};

var Recoil_mapMap = function Recoil_mapMap(map, callback) {
  var result = new Map();
  return map.forEach(function (value, key) {
    result.set(key, callback(value, key));
  }), result;
};

var Recoil_mergeMaps = function Recoil_mergeMaps() {
  var result = new Map();

  for (var _len3 = arguments.length, maps = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    maps[_key3] = arguments[_key3];
  }

  for (var i = 0; i < maps.length; i++) {
    var iterator = maps[i].keys();
    var nextKey = void 0;

    for (; !(nextKey = iterator.next()).done;) {
      result.set(nextKey.value, maps[i].get(nextKey.value));
    }
  }

  return result;
};

var useCallback = react.useCallback,
    useEffect$1 = react.useEffect,
    useMemo = react.useMemo,
    useRef$1 = react.useRef,
    useState$1 = react.useState,
    setByAddingToSet$2 = Recoil_CopyOnWrite.setByAddingToSet,
    getNodeLoadable$2 = Recoil_FunctionalCore.getNodeLoadable,
    peekNodeLoadable$2 = Recoil_FunctionalCore.peekNodeLoadable,
    setNodeValue$3 = Recoil_FunctionalCore.setNodeValue,
    DEFAULT_VALUE$1 = Recoil_Node.DEFAULT_VALUE,
    RecoilValueNotReady$1 = Recoil_Node.RecoilValueNotReady,
    getNode$2 = Recoil_Node.getNode,
    nodes$1 = Recoil_Node.nodes,
    useStoreRef$1 = Recoil_RecoilRoot_react.useStoreRef,
    AbstractRecoilValue$2 = Recoil_RecoilValue.AbstractRecoilValue,
    getRecoilValueAsLoadable$1 = Recoil_RecoilValue.getRecoilValueAsLoadable,
    setRecoilValue$1 = Recoil_RecoilValue.setRecoilValue,
    setUnvalidatedRecoilValue$1 = Recoil_RecoilValue.setUnvalidatedRecoilValue,
    subscribeToRecoilValue$1 = Recoil_RecoilValue.subscribeToRecoilValue;

function cloneState(state, opts) {
  return {
    isSnapshot: opts.isSnapshot,
    transactionMetadata: _objectSpread({}, state.transactionMetadata),
    atomValues: new Map(state.atomValues),
    nonvalidatedAtoms: new Map(state.nonvalidatedAtoms),
    dirtyAtoms: new Set(state.dirtyAtoms),
    nodeDeps: new Map(state.nodeDeps),
    nodeToNodeSubscriptions: Recoil_mapMap(state.nodeToNodeSubscriptions, function (keys) {
      return new Set(keys);
    }),
    nodeToComponentSubscriptions: Recoil_mapMap(state.nodeToComponentSubscriptions, function (subsByAtom) {
      return new Map(subsByAtom);
    })
  };
}

function valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater) {
  if ("function" == typeof valueOrUpdater) {
    var current = peekNodeLoadable$2(store, state, recoilValue.key);
    if ("loading" === current.state) throw new RecoilValueNotReady$1(recoilValue.key);
    if ("hasError" === current.state) throw current.contents;
    return valueOrUpdater(current.contents);
  }

  return valueOrUpdater;
}

function useInterface() {
  var storeRef = useStoreRef$1(),
      _useState$ = useState$1([]),
      _useState$2 = _slicedToArray(_useState$, 2),
      _ = _useState$2[0],
      forceUpdate = _useState$2[1],
      recoilValuesUsed = useRef$1(new Set());

  recoilValuesUsed.current = new Set();
  var previousSubscriptions = useRef$1(new Set()),
      subscriptions = useRef$1(new Map()),
      unsubscribeFrom = useCallback(function (key) {
    var sub = subscriptions.current.get(key);
    sub && (sub.release(storeRef.current), subscriptions.current["delete"](key));
  }, [storeRef, subscriptions]);
  return useEffect$1(function () {
    var store = storeRef.current;

    function updateState(_state, key) {
      subscriptions.current.has(key) && forceUpdate([]);
    }

    Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach(function (key) {
      if (subscriptions.current.has(key)) return;
      var sub = subscribeToRecoilValue$1(store, new AbstractRecoilValue$2(key), function (state) {
        Recoil_Tracing.trace("RecoilValue subscription fired", key, function () {
          updateState(0, key);
        });
      });
      subscriptions.current.set(key, sub), Recoil_Tracing.trace("initial update on subscribing", key, function () {
        updateState(store.getState(), key);
      });
    }), Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach(function (key) {
      unsubscribeFrom(key);
    }), previousSubscriptions.current = recoilValuesUsed.current;
  }), useEffect$1(function () {
    var subs = subscriptions.current;
    return function () {
      return subs.forEach(function (_, key) {
        return unsubscribeFrom(key);
      });
    };
  }, [unsubscribeFrom]), useMemo(function () {
    function useSetRecoilState(recoilState) {
      return function (newValueOrUpdater) {
        var _storeState$nextTree;

        var storeState = storeRef.current.getState(),
            newValue = valueFromValueOrUpdater(storeRef.current, null !== (_storeState$nextTree = storeState.nextTree) && void 0 !== _storeState$nextTree ? _storeState$nextTree : storeState.currentTree, recoilState, newValueOrUpdater);
        setRecoilValue$1(storeRef.current, recoilState, newValue);
      };
    }

    function useRecoilValueLoadable(recoilValue) {
      return recoilValuesUsed.current.has(recoilValue.key) || (recoilValuesUsed.current = setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key)), getRecoilValueAsLoadable$1(storeRef.current, recoilValue);
    }

    function useRecoilValue(recoilValue) {
      return function (loadable, atom, storeRef) {
        if ("hasValue" === loadable.state) return loadable.contents;

        if ("loading" === loadable.state) {
          throw new Promise(function (resolve) {
            storeRef.current.getState().suspendedComponentResolvers.add(resolve);
          });
        }

        throw "hasError" === loadable.state ? loadable.contents : new Error("Invalid value of loadable atom \"".concat(atom.key, "\""));
      }(useRecoilValueLoadable(recoilValue), recoilValue, storeRef);
    }

    return {
      getRecoilValue: useRecoilValue,
      getRecoilValueLoadable: useRecoilValueLoadable,
      getRecoilState: function getRecoilState(recoilState) {
        return [useRecoilValue(recoilState), useSetRecoilState(recoilState)];
      },
      getRecoilStateLoadable: function getRecoilStateLoadable(recoilState) {
        return [useRecoilValueLoadable(recoilState), useSetRecoilState(recoilState)];
      },
      getSetRecoilState: useSetRecoilState,
      getResetRecoilState: function getResetRecoilState(recoilState) {
        return function () {
          return setRecoilValue$1(storeRef.current, recoilState, DEFAULT_VALUE$1);
        };
      }
    };
  }, [recoilValuesUsed, storeRef]);
}

function useTransactionSubscription(callback) {
  var storeRef = useStoreRef$1();
  useEffect$1(function () {
    return storeRef.current.subscribeToTransactions(callback).release;
  }, [callback, storeRef]);
}

function externallyVisibleAtomValuesInState(state) {
  var atomValues = state.atomValues,
      persistedAtomContentsValues = Recoil_mapMap(Recoil_filterMap(atomValues, function (v, k) {
    var _node$options;

    var persistence = null === (_node$options = getNode$2(k).options) || void 0 === _node$options ? void 0 : _node$options.persistence_UNSTABLE;
    return null != persistence && "none" !== persistence.type && "hasValue" === v.state;
  }), function (v) {
    return v.contents;
  });
  return Recoil_mergeMaps(state.nonvalidatedAtoms, persistedAtomContentsValues);
}

var Sentinel = function Sentinel() {
  _classCallCheck(this, Sentinel);
};

var SENTINEL = new Sentinel();
var Recoil_Hooks = {
  useRecoilCallback: function useRecoilCallback(fn, deps) {
    var storeRef = useStoreRef$1();
    return useCallback(function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var snapshot = cloneState(storeRef.current.getState().currentTree, {
        isSnapshot: !0
      });

      function getLoadable(recoilValue) {
        var _getNodeLoadable$3, _getNodeLoadable$4;

        var result;
        return (_getNodeLoadable$3 = getNodeLoadable$2(storeRef.current, snapshot, recoilValue.key), _getNodeLoadable$4 = _slicedToArray(_getNodeLoadable$3, 2), snapshot = _getNodeLoadable$4[0], result = _getNodeLoadable$4[1], _getNodeLoadable$3), result;
      }

      function getPromise(recoilValue) {
        return getLoadable(recoilValue).toPromise();
      }

      function set(recoilState, newValueOrUpdater) {
        var newValue = valueFromValueOrUpdater(storeRef.current, snapshot, recoilState, newValueOrUpdater);
        setRecoilValue$1(storeRef.current, recoilState, newValue);
      }

      function reset(recoilState) {
        setRecoilValue$1(storeRef.current, recoilState, DEFAULT_VALUE$1);
      }

      var ret = SENTINEL;
      return reactDom.unstable_batchedUpdates(function () {
        ret = fn.apply(void 0, [{
          getPromise: getPromise,
          getLoadable: getLoadable,
          set: set,
          reset: reset
        }].concat(args));
      }), Recoil_invariant(!(ret instanceof Sentinel), "unstable_batchedUpdates should return immediately"), ret;
    }, null != deps ? [].concat(_toConsumableArray(deps), [storeRef]) : void 0);
  },
  useRecoilValue: function useRecoilValue(recoilValue) {
    return useInterface().getRecoilValue(recoilValue);
  },
  useRecoilValueLoadable: function useRecoilValueLoadable(recoilValue) {
    return useInterface().getRecoilValueLoadable(recoilValue);
  },
  useRecoilState: function useRecoilState(recoilState) {
    var recoilInterface = useInterface(),
        _recoilInterface$getR = recoilInterface.getRecoilState(recoilState),
        _recoilInterface$getR2 = _slicedToArray(_recoilInterface$getR, 1),
        value = _recoilInterface$getR2[0];

    return [value, useCallback(recoilInterface.getSetRecoilState(recoilState), [recoilState])];
  },
  useRecoilStateLoadable: function useRecoilStateLoadable(recoilState) {
    var recoilInterface = useInterface(),
        _recoilInterface$getR3 = recoilInterface.getRecoilStateLoadable(recoilState),
        _recoilInterface$getR4 = _slicedToArray(_recoilInterface$getR3, 1),
        value = _recoilInterface$getR4[0];

    return [value, useCallback(recoilInterface.getSetRecoilState(recoilState), [recoilState])];
  },
  useSetRecoilState: function useSetRecoilState(recoilState) {
    return useCallback(useInterface().getSetRecoilState(recoilState), [recoilState]);
  },
  useResetRecoilState: function useResetRecoilState(recoilState) {
    return useCallback(useInterface().getResetRecoilState(recoilState), [recoilState]);
  },
  useRecoilInterface: useInterface,
  useTransactionSubscription: useTransactionSubscription,
  useSnapshotWithStateChange: function useSnapshotWithStateChange(transaction) {
    var storeRef = useStoreRef$1();

    var snapshot = function () {
      var _useState$3 = useState$1(0),
          _useState$4 = _slicedToArray(_useState$3, 2),
          _ = _useState$4[0],
          setState = _useState$4[1];

      return useTransactionSubscription(useCallback(function () {
        return setState(function (x) {
          return x + 1;
        });
      }, [])), cloneState(useStoreRef$1().current.getState().currentTree, {
        isSnapshot: !0
      });
    }();

    transaction(function (_ref9, updater) {
      var key = _ref9.key;

      var _setNodeValue$3 = setNodeValue$3(storeRef.current, snapshot, key, peekNodeLoadable$2(storeRef.current, snapshot, key).map(updater));

      var _setNodeValue$4 = _slicedToArray(_setNodeValue$3, 1);

      snapshot = _setNodeValue$4[0];
    });
    var atomValues = Recoil_mapMap(snapshot.atomValues, function (v) {
      return v.contents;
    }),
        updatedAtoms = Recoil_intersectSets(snapshot.dirtyAtoms, new Set(atomValues.keys()));
    return {
      atomValues: atomValues,
      updatedAtoms: updatedAtoms
    };
  },
  useTransactionObservation: function useTransactionObservation(callback) {
    useTransactionSubscription(useCallback(function (store, previousState) {
      var nextTree = store.getState().nextTree;
      nextTree || (nextTree = store.getState().currentTree);
      var atomValues = externallyVisibleAtomValuesInState(nextTree),
          previousAtomValues = externallyVisibleAtomValuesInState(previousState),
          atomInfo = Recoil_mapMap(nodes$1, function (node) {
        var _node$options$persist, _node$options2, _node$options2$persis, _node$options$persist2, _node$options3, _node$options3$persis;

        return {
          persistence_UNSTABLE: {
            type: null !== (_node$options$persist = null === (_node$options2 = node.options) || void 0 === _node$options2 || null === (_node$options2$persis = _node$options2.persistence_UNSTABLE) || void 0 === _node$options2$persis ? void 0 : _node$options2$persis.type) && void 0 !== _node$options$persist ? _node$options$persist : "none",
            backButton: null !== (_node$options$persist2 = null === (_node$options3 = node.options) || void 0 === _node$options3 || null === (_node$options3$persis = _node$options3.persistence_UNSTABLE) || void 0 === _node$options3$persis ? void 0 : _node$options3$persis.backButton) && void 0 !== _node$options$persist2 && _node$options$persist2
          }
        };
      }),
          modifiedAtoms = new Set(nextTree.dirtyAtoms);
      callback({
        atomValues: atomValues,
        previousAtomValues: previousAtomValues,
        atomInfo: atomInfo,
        modifiedAtoms: modifiedAtoms,
        transactionMetadata: _objectSpread({}, nextTree.transactionMetadata)
      });
    }, [callback]));
  },
  useGoToSnapshot: function useGoToSnapshot() {
    var storeRef = useStoreRef$1();
    return function (snapshot) {
      reactDom.unstable_batchedUpdates(function () {
        snapshot.updatedAtoms.forEach(function (key) {
          setRecoilValue$1(storeRef.current, new AbstractRecoilValue$2(key), snapshot.atomValues.get(key));
        });
      });
    };
  },
  useSetUnvalidatedAtomValues: function useSetUnvalidatedAtomValues() {
    var storeRef = useStoreRef$1();
    return function (values) {
      var transactionMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      reactDom.unstable_batchedUpdates(function () {
        storeRef.current.addTransactionMetadata(transactionMetadata), values.forEach(function (value, key) {
          return setUnvalidatedRecoilValue$1(storeRef.current, new AbstractRecoilValue$2(key), value);
        });
      });
    };
  }
};

var Recoil_isPromise = function Recoil_isPromise(p) {
  return !!p && "function" == typeof p.then;
};

var loadableAccessors = {
  getValue: function getValue() {
    if ("hasValue" !== this.state) throw this.contents;
    return this.contents;
  },
  toPromise: function toPromise() {
    return "hasValue" === this.state ? Promise.resolve(this.contents) : "hasError" === this.state ? Promise.reject(this.contents) : this.contents;
  },
  valueMaybe: function valueMaybe() {
    return "hasValue" === this.state ? this.contents : void 0;
  },
  valueOrThrow: function valueOrThrow() {
    if ("hasValue" !== this.state) throw new Error("Loadable expected value, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  errorMaybe: function errorMaybe() {
    return "hasError" === this.state ? this.contents : void 0;
  },
  errorOrThrow: function errorOrThrow() {
    if ("hasError" !== this.state) throw new Error("Loadable expected error, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  promiseMaybe: function promiseMaybe() {
    return "loading" === this.state ? this.contents : void 0;
  },
  promiseOrThrow: function promiseOrThrow() {
    if ("loading" !== this.state) throw new Error("Loadable expected promise, but in \"".concat(this.state, "\" state"));
    return this.contents;
  },
  map: function map(_map) {
    var _this = this;

    if ("hasError" === this.state) return this;
    if ("hasValue" === this.state) try {
      var next = _map(this.contents);

      return Recoil_isPromise(next) ? loadableWithPromise(next) : loadableWithValue(next);
    } catch (e) {
      return Recoil_isPromise(e) ? loadableWithPromise(e.next(function () {
        return _map(_this.contents);
      })) : loadableWithError(e);
    }
    if ("loading" === this.state) return loadableWithPromise(this.contents.then(_map)["catch"](function (e) {
      if (Recoil_isPromise(e)) return e.then(function () {
        return _map(_this.contents);
      });
      throw e;
    }));
    throw new Error("Invalid Loadable state");
  }
};

function loadableWithValue(value) {
  return Object.freeze(_objectSpread({
    state: "hasValue",
    contents: value
  }, loadableAccessors));
}

function loadableWithError(error) {
  return Object.freeze(_objectSpread({
    state: "hasError",
    contents: error
  }, loadableAccessors));
}

function loadableWithPromise(promise) {
  return Object.freeze(_objectSpread({
    state: "loading",
    contents: promise
  }, loadableAccessors));
}

var Recoil_Loadable = {
  loadableWithValue: loadableWithValue,
  loadableWithError: loadableWithError,
  loadableWithPromise: loadableWithPromise,
  loadableLoading: function loadableLoading() {
    return loadableWithPromise(new Promise(function () {}));
  },
  loadableAll: function loadableAll(inputs) {
    return inputs.every(function (i) {
      return "hasValue" === i.state;
    }) ? loadableWithValue(inputs.map(function (i) {
      return i.contents;
    })) : inputs.some(function (i) {
      return "hasError" === i.state;
    }) ? loadableWithError(Recoil_nullthrows(inputs.find(function (i) {
      return "hasError" === i.state;
    }), "Invalid loadable passed to loadableAll").contents) : loadableWithPromise(Promise.all(inputs.map(function (i) {
      return i.contents;
    })));
  }
};

var Recoil_isNode = function Recoil_isNode(object) {
  var _ownerDocument, _doc$defaultView;

  if ("undefined" == typeof window) return !1;
  var defaultView = null !== (_doc$defaultView = (null != object ? null !== (_ownerDocument = object.ownerDocument) && void 0 !== _ownerDocument ? _ownerDocument : object : document).defaultView) && void 0 !== _doc$defaultView ? _doc$defaultView : window;
  return !(null == object || !("function" == typeof defaultView.Node ? object instanceof defaultView.Node : "object" == typeof object && "number" == typeof object.nodeType && "string" == typeof object.nodeName));
};

var Recoil_deepFreezeValue = function deepFreezeValue(value) {
  if ("object" == typeof value && !function (value) {
    if (null === value || "object" != typeof value) return !0;

    switch (typeof value.$$typeof) {
      case "symbol":
      case "number":
        return !0;
    }

    return null != value["@@__IMMUTABLE_ITERABLE__@@"] || null != value["@@__IMMUTABLE_KEYED__@@"] || null != value["@@__IMMUTABLE_INDEXED__@@"] || null != value["@@__IMMUTABLE_ORDERED__@@"] || null != value["@@__IMMUTABLE_RECORD__@@"] || !!Recoil_isNode(value) || !!Recoil_isPromise(value);
  }(value)) {
    Object.freeze(value);

    for (var key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        var prop = value[key];
        "object" != typeof prop || null == prop || Object.isFrozen(prop) || deepFreezeValue(prop);
      }
    }

    Object.seal(value);
  }
};

var LEAF = Symbol("ArrayKeyedMap"),
    emptyMap$1 = new Map();

var ArrayKeyedMap = /*#__PURE__*/function () {
  function ArrayKeyedMap(existing) {
    _classCallCheck(this, ArrayKeyedMap);

    if (this._base = new Map(), existing instanceof ArrayKeyedMap) {
      var _iterator9 = _createForOfIteratorHelper(existing.entries()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _step9$value = _slicedToArray(_step9.value, 2),
              k = _step9$value[0],
              v = _step9$value[1];

          this.set(k, v);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    } else if (existing) {
      var _iterator10 = _createForOfIteratorHelper(existing),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var _step10$value = _slicedToArray(_step10.value, 2),
              _k = _step10$value[0],
              _v = _step10$value[1];

          this.set(_k, _v);
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }

    return this;
  }

  _createClass(ArrayKeyedMap, [{
    key: "get",
    value: function get(key) {
      var ks = Array.isArray(key) ? key : [key];
      var map = this._base;
      return ks.forEach(function (k) {
        var _map$get;

        map = null !== (_map$get = map.get(k)) && void 0 !== _map$get ? _map$get : emptyMap$1;
      }), void 0 === map ? void 0 : map.get(LEAF);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      var ks = Array.isArray(key) ? key : [key];
      var map = this._base,
          next = map;
      return ks.forEach(function (k) {
        next = map.get(k), next || (next = new Map(), map.set(k, next)), map = next;
      }), next.set(LEAF, value), this;
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      var ks = Array.isArray(key) ? key : [key];
      var map = this._base,
          next = map;
      return ks.forEach(function (k) {
        next = map.get(k), next || (next = new Map(), map.set(k, next)), map = next;
      }), next["delete"](LEAF), this;
    }
  }, {
    key: "entries",
    value: function entries() {
      var answer = [];
      return function recurse(level, prefix) {
        level.forEach(function (v, k) {
          k === LEAF ? answer.push([prefix, v]) : recurse(v, prefix.concat(k));
        });
      }(this._base, []), answer.values();
    }
  }, {
    key: "toBuiltInMap",
    value: function toBuiltInMap() {
      return new Map(this.entries());
    }
  }]);

  return ArrayKeyedMap;
}();

var Recoil_ArrayKeyedMap = ArrayKeyedMap;

var Recoil_cacheWithReferenceEquality = function Recoil_cacheWithReferenceEquality() {
  return new Recoil_ArrayKeyedMap();
};

var Recoil_everySet = function Recoil_everySet(set, callback, context) {
  var iterator = set.entries();
  var current = iterator.next();

  for (; !current.done;) {
    var entry = current.value;
    if (!callback.call(context, entry[1], entry[0], set)) return !1;
    current = iterator.next();
  }

  return !0;
};

var Recoil_equalsSet = function Recoil_equalsSet(one, two) {
  return one.size === two.size && Recoil_everySet(one, function (value) {
    return two.has(value);
  });
};

var Recoil_PerformanceTimings = {
  startPerfBlock: function startPerfBlock(_id) {
    return function () {
      return null;
    };
  }
};
Object.freeze(new Set());
var mapBySettingInMap$2 = Recoil_CopyOnWrite.mapBySettingInMap,
    mapByUpdatingInMap$2 = Recoil_CopyOnWrite.mapByUpdatingInMap,
    setByAddingToSet$3 = Recoil_CopyOnWrite.setByAddingToSet,
    setByDeletingFromSet$1 = Recoil_CopyOnWrite.setByDeletingFromSet,
    detectCircularDependencies$1 = Recoil_FunctionalCore.detectCircularDependencies,
    getNodeLoadable$3 = Recoil_FunctionalCore.getNodeLoadable,
    setNodeValue$4 = Recoil_FunctionalCore.setNodeValue,
    loadableWithError$1 = Recoil_Loadable.loadableWithError,
    loadableWithPromise$1 = Recoil_Loadable.loadableWithPromise,
    loadableWithValue$1 = Recoil_Loadable.loadableWithValue,
    DEFAULT_VALUE$2 = Recoil_Node.DEFAULT_VALUE,
    RecoilValueNotReady$2 = Recoil_Node.RecoilValueNotReady,
    registerNode$1 = Recoil_Node.registerNode,
    startPerfBlock$1 = Recoil_PerformanceTimings.startPerfBlock,
    isRecoilValue$1 = Recoil_RecoilValue.isRecoilValue,
    emptySet$2 = Object.freeze(new Set());

function cacheKeyFromDepValues(depValues) {
  var answer = [];

  var _iterator11 = _createForOfIteratorHelper(Array.from(depValues.keys()).sort()),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var key = _step11.value;
      var loadable = Recoil_nullthrows(depValues.get(key));
      answer.push(key), answer.push(loadable.contents);
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return answer;
}

var Recoil_selector = function Recoil_selector(options) {
  var key = options.key,
      get = options.get,
      cacheImplementation = options.cacheImplementation_UNSTABLE,
      _set = null != options.set ? options.set : void 0;

  var cache = null != cacheImplementation ? cacheImplementation : Recoil_cacheWithReferenceEquality();

  function getFromCache(store, state) {
    var _state$nodeDeps$get;

    var newState = state;
    var currentDeps = null !== (_state$nodeDeps$get = state.nodeDeps.get(key)) && void 0 !== _state$nodeDeps$get ? _state$nodeDeps$get : emptySet$2,
        cacheKey = cacheKeyFromDepValues(new Map(Array.from(currentDeps).sort().map(function (depKey) {
      var _getNodeLoadable$5 = getNodeLoadable$3(store, newState, depKey),
          _getNodeLoadable$6 = _slicedToArray(_getNodeLoadable$5, 2),
          nextState = _getNodeLoadable$6[0],
          loadable = _getNodeLoadable$6[1];

      return newState = nextState, [depKey, loadable];
    }))),
        cached = cache.get(cacheKey);
    if (null != cached) return [newState, cached];

    var _ref10 = function (store, state) {
      var _state$nodeDeps$get2;

      var _ref12 = function (store, state) {
        var endPerfBlock = startPerfBlock$1(key);
        var newState = state;
        var depValues = new Map();

        function getRecoilValue(_ref14) {
          var _getNodeLoadable$7, _getNodeLoadable$8;

          var key = _ref14.key;
          var loadable;
          if ((_getNodeLoadable$7 = getNodeLoadable$3(store, state, key), _getNodeLoadable$8 = _slicedToArray(_getNodeLoadable$7, 2), newState = _getNodeLoadable$8[0], loadable = _getNodeLoadable$8[1], _getNodeLoadable$7), depValues.set(key, loadable), "hasValue" === loadable.state) return loadable.contents;
          throw loadable.contents;
        }

        try {
          var output = get({
            get: getRecoilValue
          }),
              result = isRecoilValue$1(output) ? getRecoilValue(output) : output,
              _loadable = Recoil_isPromise(result) ? loadableWithPromise$1(result["finally"](endPerfBlock)) : (endPerfBlock(), loadableWithValue$1(result));

          return [newState, _loadable, depValues];
        } catch (errorOrDepPromise) {
          var _loadable2 = Recoil_isPromise(errorOrDepPromise) ? loadableWithPromise$1(errorOrDepPromise.then(function () {
            var loadable = loadableWithError$1(new Error("Internal Recoil Selector Error"));
            if (store.replaceState(function (asyncState) {
              var _getFromCache, _getFromCache2;

              var newAsyncState;
              return (_getFromCache = getFromCache(store, asyncState), _getFromCache2 = _slicedToArray(_getFromCache, 2), newAsyncState = _getFromCache2[0], loadable = _getFromCache2[1], _getFromCache), newAsyncState;
            }), "hasError" === loadable.state) throw loadable.contents;
            return loadable.contents;
          })["finally"](endPerfBlock)) : (endPerfBlock(), loadableWithError$1(errorOrDepPromise));

          return [newState, _loadable2, depValues];
        }
      }(store, state),
          _ref13 = _slicedToArray(_ref12, 3),
          newStateFromEvaluate = _ref13[0],
          loadable = _ref13[1],
          newDepValues = _ref13[2];

      var newState = newStateFromEvaluate;
      var oldDeps = null !== (_state$nodeDeps$get2 = state.nodeDeps.get(key)) && void 0 !== _state$nodeDeps$get2 ? _state$nodeDeps$get2 : emptySet$2,
          newDeps = new Set(newDepValues.keys());
      newState = Recoil_equalsSet(oldDeps, newDeps) ? newState : _objectSpread(_objectSpread({}, newState), {}, {
        nodeDeps: mapBySettingInMap$2(newState.nodeDeps, key, newDeps)
      });
      var addedDeps = Recoil_differenceSets(newDeps, oldDeps),
          removedDeps = Recoil_differenceSets(oldDeps, newDeps);

      var _iterator12 = _createForOfIteratorHelper(addedDeps),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var upstreamNode = _step12.value;
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            nodeToNodeSubscriptions: mapByUpdatingInMap$2(newState.nodeToNodeSubscriptions, upstreamNode, function (subs) {
              return setByAddingToSet$3(null != subs ? subs : emptySet$2, key);
            })
          });
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      var _iterator13 = _createForOfIteratorHelper(removedDeps),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var _upstreamNode = _step13.value;
          newState = _objectSpread(_objectSpread({}, newState), {}, {
            nodeToNodeSubscriptions: mapByUpdatingInMap$2(newState.nodeToNodeSubscriptions, _upstreamNode, function (subs) {
              return setByDeletingFromSet$1(null != subs ? subs : emptySet$2, key);
            })
          });
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return [newState, loadable, newDepValues];
    }(store, newState),
        _ref11 = _slicedToArray(_ref10, 3),
        nextState = _ref11[0],
        loadable = _ref11[1],
        newDepValues = _ref11[2];

    newState = nextState;
    var newCacheKey = cacheKeyFromDepValues(newDepValues);
    return function (store, cacheKey, loadable) {
      "loading" !== loadable.state ? !0 == !options.dangerouslyAllowMutability && Recoil_deepFreezeValue(loadable.contents) : loadable.contents.then(function (result) {
        return !0 == !options.dangerouslyAllowMutability && Recoil_deepFreezeValue(result), cache = cache.set(cacheKey, loadableWithValue$1(result)), store.fireNodeSubscriptions(new Set([key]), "now"), result;
      })["catch"](function (error) {
        return Recoil_isPromise(error) || (!0 == !options.dangerouslyAllowMutability && Recoil_deepFreezeValue(error), cache = cache.set(cacheKey, loadableWithError$1(error)), store.fireNodeSubscriptions(new Set([key]), "now")), error;
      }), cache = cache.set(cacheKey, loadable);
    }(store, newCacheKey, loadable), [newState, loadable];
  }

  function myGet(store, state) {
    return getFromCache(store, state);
  }

  if (null != _set) {
    return registerNode$1({
      key: key,
      options: options,
      get: myGet,
      set: function set(store, state, newValue) {
        var newState = state;
        var writtenNodes = new Set();

        function getRecoilValue(_ref15) {
          var key = _ref15.key;

          var _getNodeLoadable$9 = getNodeLoadable$3(store, newState, key),
              _getNodeLoadable$10 = _slicedToArray(_getNodeLoadable$9, 2),
              nextState = _getNodeLoadable$10[0],
              loadable = _getNodeLoadable$10[1];

          if (newState = nextState, "hasValue" === loadable.state) return loadable.contents;
          throw "loading" === loadable.state ? new RecoilValueNotReady$2(key) : loadable.contents;
        }

        function setRecoilState(recoilState, valueOrUpdater) {
          var _setNodeValue$5, _setNodeValue$6;

          var newValue = "function" == typeof valueOrUpdater ? valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
          var written;
          (_setNodeValue$5 = setNodeValue$4(store, newState, recoilState.key, newValue), _setNodeValue$6 = _slicedToArray(_setNodeValue$5, 2), newState = _setNodeValue$6[0], written = _setNodeValue$6[1], _setNodeValue$5), written.forEach(function (atom) {
            return writtenNodes.add(atom);
          });
        }

        return _set({
          set: setRecoilState,
          get: getRecoilValue,
          reset: function reset(recoilState) {
            setRecoilState(recoilState, DEFAULT_VALUE$2);
          }
        }, newValue), [newState, writtenNodes];
      }
    });
  }

  return registerNode$1({
    key: key,
    options: options,
    get: myGet
  });
};

var loadableWithValue$2 = Recoil_Loadable.loadableWithValue,
    DEFAULT_VALUE$3 = Recoil_Node.DEFAULT_VALUE,
    DefaultValue$1 = Recoil_Node.DefaultValue,
    registerNode$2 = Recoil_Node.registerNode,
    isRecoilValue$2 = Recoil_RecoilValue.isRecoilValue,
    mapByDeletingFromMap$2 = Recoil_CopyOnWrite.mapByDeletingFromMap,
    mapBySettingInMap$3 = Recoil_CopyOnWrite.mapBySettingInMap,
    setByAddingToSet$4 = Recoil_CopyOnWrite.setByAddingToSet;

function atom(options) {
  var optionsDefault = options["default"],
      restOptions = _objectWithoutProperties(options, ["default"]);

  return isRecoilValue$2(optionsDefault) || Recoil_isPromise(optionsDefault) ? function (options) {
    var base = atom(_objectSpread(_objectSpread({}, options), {}, {
      "default": DEFAULT_VALUE$3,
      persistence_UNSTABLE: void 0 === options.persistence_UNSTABLE ? void 0 : _objectSpread(_objectSpread({}, options.persistence_UNSTABLE), {}, {
        validator: function validator(storedValue) {
          return storedValue instanceof DefaultValue$1 ? storedValue : Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, DEFAULT_VALUE$3);
        }
      })
    }));
    return Recoil_selector({
      key: options.key + "__withFallback",
      get: function get(_ref16) {
        var _get = _ref16.get;

        var baseValue = _get(base);

        return baseValue instanceof DefaultValue$1 ? options["default"] : baseValue;
      },
      set: function set(_ref17, newValue) {
        var _set2 = _ref17.set;
        return _set2(base, newValue);
      },
      dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
  }(_objectSpread(_objectSpread({}, restOptions), {}, {
    "default": optionsDefault
  })) : function (options) {
    var key = options.key,
        persistence = options.persistence_UNSTABLE;
    return registerNode$2({
      key: key,
      options: options,
      get: function get(_store, state) {
        if (state.atomValues.has(key)) return [state, Recoil_nullthrows(state.atomValues.get(key))];

        if (state.nonvalidatedAtoms.has(key)) {
          if (null == persistence) return [state, loadableWithValue$2(options["default"])];
          var nonvalidatedValue = state.nonvalidatedAtoms.get(key),
              validatedValue = persistence.validator(nonvalidatedValue, DEFAULT_VALUE$3);
          return validatedValue instanceof DefaultValue$1 ? [_objectSpread(_objectSpread({}, state), {}, {
            nonvalidatedAtoms: mapByDeletingFromMap$2(state.nonvalidatedAtoms, key)
          }), loadableWithValue$2(options["default"])] : [_objectSpread(_objectSpread({}, state), {}, {
            atomValues: mapBySettingInMap$3(state.atomValues, key, loadableWithValue$2(validatedValue)),
            nonvalidatedAtoms: mapByDeletingFromMap$2(state.nonvalidatedAtoms, key)
          }), loadableWithValue$2(validatedValue)];
        }

        return [state, loadableWithValue$2(options["default"])];
      },
      set: function set(_store, state, newValue) {
        return !0 !== options.dangerouslyAllowMutability && Recoil_deepFreezeValue(newValue), [_objectSpread(_objectSpread({}, state), {}, {
          dirtyAtoms: setByAddingToSet$4(state.dirtyAtoms, key),
          atomValues: newValue instanceof DefaultValue$1 ? mapByDeletingFromMap$2(state.atomValues, key) : mapBySettingInMap$3(state.atomValues, key, loadableWithValue$2(newValue)),
          nonvalidatedAtoms: mapByDeletingFromMap$2(state.nonvalidatedAtoms, key)
        }), new Set([key])];
      }
    });
  }(_objectSpread(_objectSpread({}, restOptions), {}, {
    "default": optionsDefault
  }));
}

var Recoil_atom = atom;

var Recoil_ParameterizedAtomTaggedValue_DEPRECATED = function Recoil_ParameterizedAtomTaggedValue_DEPRECATED(value) {
  _classCallCheck(this, Recoil_ParameterizedAtomTaggedValue_DEPRECATED);

  this.value = value;
};

var Recoil_stableStringify = function Recoil_stableStringify(x, opt) {
  window.performance && window.performance.now();

  var str = function stringify(x, opt, key) {
    if ("string" == typeof x && !x.includes('"') && !x.includes("\\")) return "\"".concat(x, "\"");

    switch (typeof x) {
      case "undefined":
        return "";

      case "boolean":
        return x ? "true" : "false";

      case "number":
      case "symbol":
        return String(x);

      case "string":
        return JSON.stringify(x);

      case "function":
        if (!0 !== (null == opt ? void 0 : opt.allowFunctions)) throw new Error("Attempt to serialize function in a Recoil cache key");
        return "__FUNCTION(".concat(x.name, ")__");
    }

    return null === x ? "null" : "object" != typeof x ? null !== (_JSON$stringify = JSON.stringify(x)) && void 0 !== _JSON$stringify ? _JSON$stringify : "" : Recoil_isPromise(x) ? "__PROMISE__" : Array.isArray(x) ? "[".concat(x.map(function (v, i) {
      return stringify(v, opt, i.toString());
    }), "]") : "function" == typeof x.toJSON ? stringify(x.toJSON(key), opt, key) : x instanceof Map ? stringify(Array.from(x).reduce(function (obj, _ref18) {
      var _ref19 = _slicedToArray(_ref18, 2),
          k = _ref19[0],
          v = _ref19[1];

      return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, "string" == typeof k ? k : stringify(k, opt), v));
    }, {}), opt, key) : x instanceof Set ? stringify(Array.from(x).sort(function (a, b) {
      return stringify(a, opt).localeCompare(stringify(b, opt));
    }), opt, key) : null != x[Symbol.iterator] && "function" == typeof x[Symbol.iterator] ? stringify(Array.from(x), opt, key) : "{".concat(Object.keys(x).filter(function (key) {
      return void 0 !== x[key];
    }).sort().map(function (key) {
      return "".concat(stringify(key, opt), ":").concat(stringify(x[key], opt, key));
    }).join(","), "}");

    var _JSON$stringify;
  }(x, null != opt ? opt : {
    allowFunctions: void 0
  });

  return window.performance && window.performance.now(), str;
};

var Recoil_cacheWithValueEquality = function Recoil_cacheWithValueEquality() {
  var map = new Map(),
      cache = {
    get: function get(key) {
      return map.get(Recoil_stableStringify(key));
    },
    set: function set(key, value) {
      return map.set(Recoil_stableStringify(key), value), cache;
    },
    map: map
  };
  return cache;
};

var nextIndex = 0;

var Recoil_selectorFamily = function Recoil_selectorFamily(options) {
  var _options$cacheImpleme, _options$cacheImpleme2;

  var selectorCache = null !== (_options$cacheImpleme = null === (_options$cacheImpleme2 = options.cacheImplementationForParams_UNSTABLE) || void 0 === _options$cacheImpleme2 ? void 0 : _options$cacheImpleme2.call(options)) && void 0 !== _options$cacheImpleme ? _options$cacheImpleme : Recoil_cacheWithValueEquality();
  return function (params) {
    var _stableStringify, _options$cacheImpleme3;

    var cachedSelector = selectorCache.get(params);
    if (null != cachedSelector) return cachedSelector;

    var myKey = "".concat(options.key, "__selectorFamily/").concat(null !== (_stableStringify = Recoil_stableStringify(params, {
      allowFunctions: !0
    })) && void 0 !== _stableStringify ? _stableStringify : "void", "/").concat(nextIndex++),
        myGet = function myGet(callbacks) {
      return options.get(params)(callbacks);
    },
        myCacheImplementation = null === (_options$cacheImpleme3 = options.cacheImplementation_UNSTABLE) || void 0 === _options$cacheImpleme3 ? void 0 : _options$cacheImpleme3.call(options);

    var newSelector;

    if (null != options.set) {
      var _set3 = options.set;
      newSelector = Recoil_selector({
        key: myKey,
        get: myGet,
        set: function set(callbacks, newValue) {
          return _set3(params)(callbacks, newValue);
        },
        cacheImplementation_UNSTABLE: myCacheImplementation,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
      });
    } else newSelector = Recoil_selector({
      key: myKey,
      get: myGet,
      cacheImplementation_UNSTABLE: myCacheImplementation,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });

    return selectorCache = selectorCache.set(params, newSelector), newSelector;
  };
};

var DEFAULT_VALUE$4 = Recoil_Node.DEFAULT_VALUE,
    DefaultValue$2 = Recoil_Node.DefaultValue;

function isSuperset(setA, setB) {
  return Recoil_everySet(setB, function (b) {
    return setA.has(b);
  });
}

var pick = function pick(object, chosenKeys) {
  return Array.from(chosenKeys).reduce(function (obj, key) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, object[key]));
  }, {});
};

function mapPersistenceSettings_DEPRECATED(settings) {
  if (null == settings) return;
  var passthrough = Object.assign({}, settings);
  return _objectSpread(_objectSpread({}, passthrough), {}, {
    validator: function validator(storedValue) {
      return storedValue instanceof Recoil_ParameterizedAtomTaggedValue_DEPRECATED ? new Recoil_ParameterizedAtomTaggedValue_DEPRECATED(storedValue.value.filter(function (_ref20) {
        var _ref21 = _slicedToArray(_ref20, 2),
            keys = _ref21[0],
            map = _ref21[1];

        return keys instanceof Set && map instanceof Map;
      }).map(function (_ref22) {
        var _ref23 = _slicedToArray(_ref22, 2),
            keys = _ref23[0],
            map = _ref23[1];

        return [keys, Array.from(map.entries()).reduce(function (acc, _ref24) {
          var _ref25 = _slicedToArray(_ref24, 2),
              k = _ref25[0],
              v = _ref25[1];

          var validatedValue = passthrough.validator(v, DEFAULT_VALUE$4);
          return validatedValue instanceof DefaultValue$2 || acc.set(k, validatedValue), acc;
        }, new Map())];
      })) : passthrough.validator(storedValue, DEFAULT_VALUE$4);
    }
  });
}

var Recoil_atomFamily = function Recoil_atomFamily(options) {
  var atomCache = Recoil_cacheWithValueEquality();
  var legacyAtomOptions = {
    key: options.key,
    "default": DEFAULT_VALUE$4,
    persistence_UNSTABLE: mapPersistenceSettings_DEPRECATED(options.persistence_UNSTABLE)
  };
  var legacyAtom;
  legacyAtom = Recoil_atom(legacyAtomOptions);
  var atomFamilyDefault = Recoil_selectorFamily({
    key: options.key + "__atomFamily/Default",
    get: function get(param) {
      return function (_ref26) {
        var get = _ref26.get;
        var legacyValue = get("function" == typeof legacyAtom ? legacyAtom(param) : legacyAtom);

        if (!(legacyValue instanceof DefaultValue$2)) {
          var upgradedValue = function (baseValue, parameter) {
            if (!(baseValue instanceof Recoil_ParameterizedAtomTaggedValue_DEPRECATED)) return baseValue;
            if ("object" != typeof parameter || null == parameter || Array.isArray(parameter)) return DEFAULT_VALUE$4;
            var entries = baseValue.value,
                parameterKeys = new Set(Object.keys(parameter));

            var _iterator14 = _createForOfIteratorHelper(entries),
                _step14;

            try {
              for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                var _step14$value = _slicedToArray(_step14.value, 2),
                    entryParameterKeys = _step14$value[0],
                    entryMap = _step14$value[1];

                if (isSuperset(parameterKeys, entryParameterKeys)) {
                  var contextOrSubcontext = parameterKeys.size === entryParameterKeys.size ? parameter : pick(parameter, entryParameterKeys),
                      value = entryMap.get(Recoil_stableStringify(contextOrSubcontext));
                  if (void 0 !== value) return value;
                }
              }
            } catch (err) {
              _iterator14.e(err);
            } finally {
              _iterator14.f();
            }

            return DEFAULT_VALUE$4;
          }(legacyValue, param);

          if (!(upgradedValue instanceof DefaultValue$2)) return upgradedValue;
        }

        return "function" == typeof options["default"] ? options["default"](param) : options["default"];
      };
    },
    dangerouslyAllowMutability: options.dangerouslyAllowMutability
  });
  return function (params) {
    var _stableStringify;

    var cachedAtom = atomCache.get(params);
    if (null != cachedAtom) return cachedAtom;
    var newAtom = Recoil_atom({
      key: "".concat(options.key, "__").concat(null !== (_stableStringify = Recoil_stableStringify(params)) && void 0 !== _stableStringify ? _stableStringify : "void"),
      "default": atomFamilyDefault(params),
      scopeRules_APPEND_ONLY_READ_THE_DOCS: (scopeRules = options.scopeRules_APPEND_ONLY_READ_THE_DOCS, param = params, null == scopeRules ? void 0 : scopeRules.map(function (rule) {
        return Array.isArray(rule) ? rule.map(function (entry) {
          return "function" == typeof entry ? entry(param) : entry;
        }) : rule;
      })),
      persistence_UNSTABLE: options.persistence_UNSTABLE,
      dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    var scopeRules, param;
    return atomCache = atomCache.set(params, newAtom), newAtom;
  };
};

var constantSelector = Recoil_selectorFamily({
  key: "__constant",
  get: function get(constant) {
    return function () {
      return constant;
    };
  },
  cacheImplementationForParams_UNSTABLE: Recoil_cacheWithReferenceEquality
});

var Recoil_const = function Recoil_const(constant) {
  return constantSelector(constant);
};

var throwingSelector = Recoil_selectorFamily({
  key: "__error",
  get: function get(message) {
    return function () {
      throw new Error(message);
    };
  },
  cacheImplementationForParams_UNSTABLE: Recoil_cacheWithReferenceEquality
});

var Recoil_error = function Recoil_error(message) {
  return throwingSelector(message);
};

var Recoil_readOnlySelector = function Recoil_readOnlySelector(atom) {
  return atom;
};

var loadableWithError$2 = Recoil_Loadable.loadableWithError,
    loadableWithPromise$2 = Recoil_Loadable.loadableWithPromise,
    loadableWithValue$3 = Recoil_Loadable.loadableWithValue;

function concurrentRequests(getRecoilValue, deps) {
  var results = Array(deps.length).fill(void 0),
      exceptions = Array(deps.length).fill(void 0);

  var _iterator15 = _createForOfIteratorHelper(deps.entries()),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var _step15$value = _slicedToArray(_step15.value, 2),
          i = _step15$value[0],
          dep = _step15$value[1];

      try {
        results[i] = getRecoilValue(dep);
      } catch (e) {
        exceptions[i] = e;
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }

  return [results, exceptions];
}

function isError(exp) {
  return null != exp && !Recoil_isPromise(exp);
}

function unwrapDependencies(dependencies) {
  return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map(function (key) {
    return dependencies[key];
  });
}

function wrapResults(dependencies, results) {
  return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce(function (out, key, idx) {
    return _objectSpread(_objectSpread({}, out), {}, _defineProperty({}, key, results[idx]));
  }, {});
}

function wrapLoadables(dependencies, results, exceptions) {
  return wrapResults(dependencies, exceptions.map(function (exception, idx) {
    return null == exception ? loadableWithValue$3(results[idx]) : Recoil_isPromise(exception) ? loadableWithPromise$2(exception) : loadableWithError$2(exception);
  }));
}

var Recoil_WaitFor = {
  waitForNone: Recoil_selectorFamily({
    key: "__waitForNone",
    get: function get(dependencies) {
      return function (_ref27) {
        var get = _ref27.get;

        var deps = unwrapDependencies(dependencies),
            _concurrentRequests = concurrentRequests(get, deps),
            _concurrentRequests2 = _slicedToArray(_concurrentRequests, 2),
            results = _concurrentRequests2[0],
            exceptions = _concurrentRequests2[1];

        return wrapLoadables(dependencies, results, exceptions);
      };
    }
  }),
  waitForAny: Recoil_selectorFamily({
    key: "__waitForAny",
    get: function get(dependencies) {
      return function (_ref28) {
        var get = _ref28.get;

        var deps = unwrapDependencies(dependencies),
            _concurrentRequests3 = concurrentRequests(get, deps),
            _concurrentRequests4 = _slicedToArray(_concurrentRequests3, 2),
            results = _concurrentRequests4[0],
            exceptions = _concurrentRequests4[1];

        if (exceptions.some(function (exp) {
          return null == exp;
        })) return wrapLoadables(dependencies, results, exceptions);
        if (exceptions.every(isError)) throw exceptions.find(isError);
        throw new Promise(function (resolve, reject) {
          var _iterator16 = _createForOfIteratorHelper(exceptions.entries()),
              _step16;

          try {
            var _loop = function _loop() {
              var _step16$value = _slicedToArray(_step16.value, 2),
                  i = _step16$value[0],
                  exp = _step16$value[1];

              Recoil_isPromise(exp) && exp.then(function (result) {
                results[i] = result, exceptions[i] = null, resolve(wrapLoadables(dependencies, results, exceptions));
              })["catch"](function (error) {
                exceptions[i] = error, exceptions.every(isError) && reject(exceptions[0]);
              });
            };

            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        });
      };
    }
  }),
  waitForAll: Recoil_selectorFamily({
    key: "__waitForAll",
    get: function get(dependencies) {
      return function (_ref29) {
        var get = _ref29.get;

        var deps = unwrapDependencies(dependencies),
            _concurrentRequests5 = concurrentRequests(get, deps),
            _concurrentRequests6 = _slicedToArray(_concurrentRequests5, 2),
            results = _concurrentRequests6[0],
            exceptions = _concurrentRequests6[1];

        if (exceptions.every(function (exp) {
          return null == exp;
        })) return wrapResults(dependencies, results);
        var error = exceptions.find(isError);
        if (null != error) throw error;
        throw Promise.all(exceptions).then(function (results) {
          return wrapResults(dependencies, results);
        });
      };
    }
  }),
  noWait: Recoil_selectorFamily({
    key: "__noWait",
    get: function get(dependency) {
      return function (_ref30) {
        var get = _ref30.get;

        try {
          return loadableWithValue$3(get(dependency));
        } catch (exception) {
          return Recoil_isPromise(exception) ? loadableWithPromise$2(exception) : loadableWithError$2(exception);
        }
      };
    }
  })
};
var RecoilRoot$1 = Recoil_RecoilRoot_react.RecoilRoot,
    DefaultValue$3 = Recoil_Node.DefaultValue,
    isRecoilValue$3 = Recoil_RecoilValue.isRecoilValue,
    useRecoilCallback$1 = Recoil_Hooks.useRecoilCallback,
    useRecoilState$1 = Recoil_Hooks.useRecoilState,
    useRecoilStateLoadable$1 = Recoil_Hooks.useRecoilStateLoadable,
    useRecoilValue$1 = Recoil_Hooks.useRecoilValue,
    useRecoilValueLoadable$1 = Recoil_Hooks.useRecoilValueLoadable,
    useResetRecoilState$1 = Recoil_Hooks.useResetRecoilState,
    useSetRecoilState$1 = Recoil_Hooks.useSetRecoilState,
    useSetUnvalidatedAtomValues$1 = Recoil_Hooks.useSetUnvalidatedAtomValues,
    useTransactionObservation$1 = Recoil_Hooks.useTransactionObservation,
    useTransactionSubscription$1 = Recoil_Hooks.useTransactionSubscription,
    noWait$1 = Recoil_WaitFor.noWait,
    waitForAll$1 = Recoil_WaitFor.waitForAll,
    waitForAny$1 = Recoil_WaitFor.waitForAny,
    waitForNone$1 = Recoil_WaitFor.waitForNone;
var Recoil_index = {
  DefaultValue: DefaultValue$3,
  RecoilRoot: RecoilRoot$1,
  atom: Recoil_atom,
  selector: Recoil_selector,
  atomFamily: Recoil_atomFamily,
  selectorFamily: Recoil_selectorFamily,
  constSelector: Recoil_const,
  errorSelector: Recoil_error,
  readOnlySelector: Recoil_readOnlySelector,
  useRecoilValue: useRecoilValue$1,
  useRecoilValueLoadable: useRecoilValueLoadable$1,
  useRecoilState: useRecoilState$1,
  useRecoilStateLoadable: useRecoilStateLoadable$1,
  useSetRecoilState: useSetRecoilState$1,
  useResetRecoilState: useResetRecoilState$1,
  useRecoilCallback: useRecoilCallback$1,
  useTransactionObservation_UNSTABLE: useTransactionObservation$1,
  useTransactionSubscription_UNSTABLE: useTransactionSubscription$1,
  useSetUnvalidatedAtomValues_UNSTABLE: useSetUnvalidatedAtomValues$1,
  noWait: noWait$1,
  waitForNone: waitForNone$1,
  waitForAny: waitForAny$1,
  waitForAll: waitForAll$1,
  isRecoilValue: isRecoilValue$3
},
    Recoil_index_1 = Recoil_index.DefaultValue,
    Recoil_index_2 = Recoil_index.RecoilRoot,
    Recoil_index_3 = Recoil_index.atom,
    Recoil_index_4 = Recoil_index.selector,
    Recoil_index_5 = Recoil_index.atomFamily,
    Recoil_index_6 = Recoil_index.selectorFamily,
    Recoil_index_7 = Recoil_index.constSelector,
    Recoil_index_8 = Recoil_index.errorSelector,
    Recoil_index_9 = Recoil_index.readOnlySelector,
    Recoil_index_10 = Recoil_index.useRecoilValue,
    Recoil_index_11 = Recoil_index.useRecoilValueLoadable,
    Recoil_index_12 = Recoil_index.useRecoilState,
    Recoil_index_13 = Recoil_index.useRecoilStateLoadable,
    Recoil_index_14 = Recoil_index.useSetRecoilState,
    Recoil_index_15 = Recoil_index.useResetRecoilState,
    Recoil_index_16 = Recoil_index.useRecoilCallback,
    Recoil_index_17 = Recoil_index.useTransactionObservation_UNSTABLE,
    Recoil_index_18 = Recoil_index.useTransactionSubscription_UNSTABLE,
    Recoil_index_19 = Recoil_index.useSetUnvalidatedAtomValues_UNSTABLE,
    Recoil_index_20 = Recoil_index.noWait,
    Recoil_index_21 = Recoil_index.waitForNone,
    Recoil_index_22 = Recoil_index.waitForAny,
    Recoil_index_23 = Recoil_index.waitForAll,
    Recoil_index_24 = Recoil_index.isRecoilValue;
exports.DefaultValue = Recoil_index_1, exports.RecoilRoot = Recoil_index_2, exports.atom = Recoil_index_3, exports.atomFamily = Recoil_index_5, exports.constSelector = Recoil_index_7, exports["default"] = Recoil_index, exports.errorSelector = Recoil_index_8, exports.isRecoilValue = Recoil_index_24, exports.noWait = Recoil_index_20, exports.readOnlySelector = Recoil_index_9, exports.selector = Recoil_index_4, exports.selectorFamily = Recoil_index_6, exports.useRecoilCallback = Recoil_index_16, exports.useRecoilState = Recoil_index_12, exports.useRecoilStateLoadable = Recoil_index_13, exports.useRecoilValue = Recoil_index_10, exports.useRecoilValueLoadable = Recoil_index_11, exports.useResetRecoilState = Recoil_index_15, exports.useSetRecoilState = Recoil_index_14, exports.useSetUnvalidatedAtomValues_UNSTABLE = Recoil_index_19, exports.useTransactionObservation_UNSTABLE = Recoil_index_17, exports.useTransactionSubscription_UNSTABLE = Recoil_index_18, exports.waitForAll = Recoil_index_23, exports.waitForAny = Recoil_index_22, exports.waitForNone = Recoil_index_21;